import { errorHandler } from "@helpers/errorHandler";
import { Call } from "@helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "@redux/actions/administrador/ui/ui";
import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { setActive as setActivePorfolio } from "./Portfolios";
import { deleteConfirmModal } from "@helpers/DeleteValidate";

/* -------------------------------------------------------------------------- */
/*                                   STATE                                    */
/* -------------------------------------------------------------------------- */

const initialState = {
    list: [],
    active: null,
    pagination: {
        current_page: 1,
        per_page: 15,
        total: 0,
        last_page: 1,
    },
};

/* -------------------------------------------------------------------------- */
/*                                   SLICE                                    */
/* -------------------------------------------------------------------------- */

const investmentsSlice = createSlice({
    name: "investments",
    initialState,
    reducers: {
        setList(state, action) {
            state.list = action.payload;
        },
        unsetList(state) {
            state.list = initialState.list;
        },
        setActive(state, action) {
            state.active = action.payload;
        },
        unsetActive(state) {
            state.active = initialState.active;
        },
        setPagination(state, action) {
            state.pagination = action.payload;
        },
        unsetPagination(state) {
            state.pagination = initialState.pagination;
        },
        reset(state) {
            Object.assign(state, initialState);
        },
    },
});

export const {
    setList,
    unsetList,
    setActive,
    unsetActive,
    setPagination,
    unsetPagination,
    reset,
} = investmentsSlice.actions;

export default investmentsSlice.reducer;

/* -------------------------------------------------------------------------- */
/*                                   THUNKS                                   */
/* -------------------------------------------------------------------------- */

export const startShowInvestments = ({
    page = 1,
    query = "",
    number_rows = 10,
    customer_id,
    portfolio_id,
}) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const params = new URLSearchParams();
        params.set("page", page);
        params.set("q", query);
        params.set("per_page", number_rows);

        if (customer_id) params.set("customer_id", customer_id);
        if (portfolio_id) params.set("portfolio_id", portfolio_id);

        const resp = await Call(
            "users/investments/show",
            "GET",
            params.toString()
        );

        if (resp.success) {
            dispatch(setPagination(resp.success));
        } else {
            errorHandler(resp);
        }

        dispatch(stopUILoading());
    };
};

export const startCreateInvestment = (
    values,
    callback = () => {},
    setErrors = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call("users/investments/create", "POST", values);

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Inversión creada correctamente.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 5000,
            });

            dispatch(setActivePorfolio(resp.success));
            callback();
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startUpdateInvestment = (
    investment_id,
    values,
    callback = () => {},
    setErrors = () => {}
) => {
    return async (dispatch) => {
        dispatch(startUILoading());

        const resp = await Call(
            `users/investments/edit/${investment_id}`,
            "POST",
            values
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Inversión actualizada.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 5000,
            });

            dispatch(setActivePorfolio(resp.success));
            callback();
        } else {
            errorHandler(resp, setErrors);
        }

        dispatch(stopUILoading());
    };
};

export const startDeleteInvestment = (investment_id, callback = () => {}) => {
    return async (dispatch) => {
        await deleteConfirmModal(async () => {
            dispatch(startUILoading());

            const resp = await Call(
                `users/investments/delete/${investment_id}`,
                "DELETE"
            );

            if (resp.success) {
                Swal.fire({
                    title: "Eliminado",
                    text: "La inversión fue eliminada.",
                    icon: "success",
                    toast: true,
                    position: "bottom-end",
                    timer: 5000,
                });

                dispatch(setActivePorfolio(resp.success));
                callback();
            } else {
                errorHandler(resp);
            }

            dispatch(stopUILoading());
        });
    };
};
